<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col cols="12">
        <b-card>
          <div slot="header">
            <span v-text="`${$lang.edit} ${$lang.role} `" />
            <strong v-text="roleName" />
          </div>
          <LoadingSpinner
            :loading="loading || loadingItem"
            :text="loadingText"
          />
          <b-form v-show="!loading && !loadingItem">
            <b-row>
              <b-col xs="12" md="12">
                <b-form-group
                  :label="$lang.caption"
                  label-for="caption"
                  :label-cols="$config.form.labelCol"
                >
                  <requiredComponent
                    slot="label"
                    :label="$lang.caption"
                    :rules="$v.caption.$params"
                  />
                  <b-form-input
                    id="name"
                    type="text"
                    :autocomplete="$lang.caption"
                    :state="$v.caption.$dirty ? !$v.caption.$error : null"
                    v-model="$v.caption.$model"
                  ></b-form-input>
                  <b-form-invalid-feedback id="caption-feedback"
                    >{{ $lang.error_required | replace($lang.caption) }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
              <b-col xs="6" md="6">
                <b-form-group
                  :label="$lang.type"
                  label-for="is_enable_selected"
                  :label-cols="12"
                >
                  <requiredComponent
                    slot="label"
                    :label="$lang.status"
                    :rules="$v.is_enable_selected.$params"
                  />
                  <b-form-radio-group
                    id="btn-radios-2"
                    v-model="$v.is_enable_selected.$model"
                    :options="is_enable_options"
                    :isValid="
                      $v.is_enable_selected.$dirty
                        ? !$v.is_enable_selected.$error
                        : null
                    "
                    buttons
                    button-variant="outline-primary"
                    size="md"
                    name="radio-btn-outline"
                  ></b-form-radio-group>
                </b-form-group>
              </b-col>
              <b-col cols="12" md="12">
                <b-card class="card_ip">
                  <div slot="header">
                    <b-row>
                      <b-col cols="6" class="d-flex align-items-center">
                        <strong v-text="$lang.valid_ip.text"></strong> &nbsp;
                        <i
                          class="fa fa-info-circle fa-lg text-info"
                          aria-hidden="true"
                          v-b-tooltip.hover
                          :title="$lang.valid_ip.sample"
                        ></i>
                      </b-col>
                      <b-col cols="6">
                        <div class="float-right">
                          <b-button
                            class="mr-1 btn-lightgray"
                            @click="addValidIP"
                          >
                            <i class="fa fa-plus"></i>
                          </b-button>
                        </div>
                      </b-col>
                    </b-row>
                  </div>

                  <div
                    v-for="(item, index) in $v.valid_ip.$each.$iter"
                    :key="index"
                  >
                    <b-col>
                      <b-row class="d-flex justify-content-center">
                        <b-col cols="10" class="p-0">
                          <b-form-group
                            label-for="valid_ip"
                            :label-cols="$config.form.labelCol"
                          >
                            <b-form-input
                              :id="index"
                              type="text"
                              autocomplete="off"
                              v-model="item.ip.$model"
                              :state="item.isValid.$model"
                              :class="
                                item.isValid.$model
                                  ? `text-success`
                                  : `text-danger`
                              "
                              @keyup="ValidateIPaddressUp(item)"
                            ></b-form-input>
                            <b-form-invalid-feedback id="caption-feedback">
                              {{
                                $lang.error_required
                                  | replace($lang.valid_ip.text)
                              }}</b-form-invalid-feedback
                            >
                          </b-form-group>
                        </b-col>
                        <b-col cols="1" class="p-0">
                          <b-form-group :label-cols="$config.form.labelCol">
                            <b-button
                              variant="outline-danger"
                              @click="removeValidIp(index)"
                            >
                              <mdicon name="close" size="20" />
                            </b-button>
                          </b-form-group>
                        </b-col>
                      </b-row>
                    </b-col>
                  </div>
                </b-card>
              </b-col>
              <b-col cols="12" md="12" class="text-right mt-3">
                <b-button class="mx-1" variant="success" @click="submit">
                  {{ $lang.submitButton }}
                  <i class="fa fa-check" />
                </b-button>
                <b-button class="mx-1" variant="danger" @click="close">
                  {{ $lang.cancelButton }}
                  <i class="fa fa-ban" />
                </b-button>
              </b-col>
            </b-row>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import LoadingSpinner from "@/components/base/LoadingSpinner";
import { required } from "vuelidate/lib/validators";
import { pathOr } from "ramda";
import { generateApiUrl } from "@/shared/utils";

export default {
  name: "edit-role",
  components: { LoadingSpinner },
  validations: {
    caption: {
      required,
    },
    is_enable_selected: {},
    valid_ip: {
      $each: {
        ip: {
          required,
        },
        isValid: {},
      },
    },
  },
  props: {
    code: {
      type: [String, Number],
      default: null,
    },
    loading: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      loadingItem: false,
      loadingText: this.$lang.receiving_data,
      caption: "",
      roleName: null,
      parentRoleLoading: false,
      valid_ip: [],
      parent_code: null,
      is_enable_selected: null,
      is_enable_options: this.$lang.role_status_list,
    };
  },
  methods: {
    pathOr,
    generateApiUrl,
    ValidateIPaddressUp(item) {
      let pattern2 =
        /([1-9]|[1-9]\d|1\d{2}|2[0-4]\d|25[0-5])(\.(\d|[1-9]\d|1\d{2}|2[0-4]\d|25[0-5])){3}\/\d+/;
      let pattern =
        /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
      let val = item.$model.ip;
      let check2 = pattern2.test(val);
      let check = pattern.test(val);
      if (check == true || check2 == true) {
        item.$model.isValid = true;
        return true;
      } else {
        item.$model.isValid = false;
        return false;
      }
    },
    removeValidIp(index) {
      this.valid_ip.splice(index, 1);
    },
    addValidIP() {
      this.valid_ip.push({
        ip: "",
        isValid: false,
      });
    },
    close() {
      this.$emit("close");
    },
    async submit() {
      this.$v.$touch();
      if (this.$v.$anyError) return;
      if (this.valid_ip.find((x) => !x.isValid)) return;

      this.loadingText = this.$lang.sending_data;
      const valid_ip = this.valid_ip
        .filter((x) => x && x.ip && x.ip != "")
        .map((x) => x.ip)
        .join();
      const payload = {
        caption: this.caption,
        parent_code: this.parent_code,
        is_enable: this.is_enable_selected,
        valid_ip,
      };

      this.$emit("submit", payload);
    },
    async fetchData() {
      try {
        this.loadingItem = true;
        this.loadingText = this.$lang.receiving_data;
        this.valid_ip = [];
        const url = generateApiUrl(["resources", "role_id"], [this.code]);
        const response = await this.$httpService.get(url);
        const data = pathOr(null, ["data", "data"], response);
        this.roleName = pathOr(null, ["name"], data);
        this.caption = pathOr(null, ["caption"], data);
        this.parent_code = pathOr(null, ["parent_code"], data);
        let validIp = pathOr([], ["valid_ip"], data);
        validIp = validIp.filter(Boolean);
        if (validIp.length) {
          this.valid_ip = validIp.map((x) => {
            return {
              ip: x,
              isValid: true,
            };
          });
        }
        this.is_enable_selected = this.is_enable_options.find(
          (x) => x.value === data.is_enable
        ).value;
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.loadingItem = false;
      }
    },
  },
  watch: {
    id() {
      this.fetchData();
    },
  },
  created() {
    this.fetchData();
  },
};
</script>

<style scoped lang="css">
.btn {
  margin-bottom: 4px;
}

.card_ip > .card-body {
  padding: 0 !important;
}
</style>
